import React from "react";

/**
 * One shared icon set. All icons are stroke-based on a 24px grid so they sit
 * together consistently; size and colour come from CSS (width/height/currentColor).
 */

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 24 24",
  "aria-hidden": true,
};

export const ArrowUpRight = () => (
  <svg {...stroke}>
    <path d="M7 17 17 7M8 7h9v9" />
  </svg>
);

export const Download = () => (
  <svg {...stroke}>
    <path d="M12 3v12m0 0 4-4m-4 4-4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
  </svg>
);

export const Menu = () => (
  <svg {...stroke}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const Close = () => (
  <svg {...stroke}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const Mail = () => (
  <svg {...stroke}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3.5 7 8.5 6 8.5-6" />
  </svg>
);

export const Linkedin = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.71h.05c.53-.95 1.83-1.96 3.77-1.96 4.03 0 4.78 2.5 4.78 5.76V21h-4v-5.6c0-1.34-.03-3.07-1.9-3.07-1.9 0-2.2 1.46-2.2 2.97V21h-3.9V9Z" />
  </svg>
);

export const Github = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.21 11.39.6.11.79-.26.79-.58v-2.23c-3.34.73-4.03-1.42-4.03-1.42-.55-1.38-1.34-1.75-1.34-1.75-1.09-.75.08-.73.08-.73 1.2.08 1.84 1.24 1.84 1.24 1.07 1.83 2.81 1.3 3.49 1 .11-.78.42-1.31.76-1.61-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.13-.3-.54-1.52.12-3.18 0 0 1-.32 3.3 1.23a11.5 11.5 0 0 1 6.01 0c2.29-1.55 3.3-1.23 3.3-1.23.66 1.66.24 2.88.12 3.18.77.84 1.23 1.91 1.23 3.22 0 4.61-2.8 5.62-5.48 5.92.43.37.82 1.1.82 2.22v3.29c0 .32.19.7.8.58A12 12 0 0 0 24 12c0-6.63-5.37-12-12-12Z" />
  </svg>
);

export const LeetCode = () => (
  <svg {...stroke}>
    <path d="M14.5 3.5 8.2 9.9a3 3 0 0 0 0 4.2l6.3 6.4" />
    <path d="M17.8 17.6 15 20.5a4 4 0 0 1-5.7 0l-2.6-2.6a4 4 0 0 1 0-5.8l2.6-2.6a4 4 0 0 1 5.7 0" />
    <path d="M10.5 12.6h8" />
  </svg>
);

export const Youtube = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M23.5 6.9a3 3 0 0 0-2.1-2.13C19.5 4.25 12 4.25 12 4.25s-7.5 0-9.4.52A3 3 0 0 0 .5 6.9C0 8.8 0 12 0 12s0 3.2.5 5.1a3 3 0 0 0 2.1 2.13c1.9.52 9.4.52 9.4.52s7.5 0 9.4-.52a3 3 0 0 0 2.1-2.13C24 15.2 24 12 24 12s0-3.2-.5-5.1ZM9.6 15.6V8.4l6.3 3.6-6.3 3.6Z" />
  </svg>
);

export const Globe = () => (
  <svg {...stroke}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z" />
  </svg>
);

/* --- Section / skill icons ------------------------------------------------ */

export const Code = () => (
  <svg {...stroke}>
    <path d="m8 17-5-5 5-5M16 7l5 5-5 5M14 4l-4 16" />
  </svg>
);

export const Layers = () => (
  <svg {...stroke}>
    <path d="m12 3 9 5-9 5-9-5 9-5Z" />
    <path d="m3 13 9 5 9-5M3 17.5l9 5 9-5" />
  </svg>
);

export const Cloud = () => (
  <svg {...stroke}>
    <path d="M7 18h10a4 4 0 0 0 .6-7.96A6 6 0 0 0 6.1 9.2 3.9 3.9 0 0 0 7 18Z" />
  </svg>
);

export const Spark = () => (
  <svg {...stroke}>
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1" />
    <circle cx="12" cy="12" r="3.2" />
  </svg>
);

export const Cap = () => (
  <svg {...stroke}>
    <path d="m12 4 10 5-10 5L2 9l10-5Z" />
    <path d="M6 11v5c0 1.3 2.7 2.5 6 2.5s6-1.2 6-2.5v-5M21 9.5v5" />
  </svg>
);

export const Certificate = () => (
  <svg {...stroke}>
    <circle cx="12" cy="9.5" r="5.5" />
    <path d="m8.5 14-1 7 4.5-2.4L16.5 21l-1-7" />
  </svg>
);

export const Briefcase = () => (
  <svg {...stroke}>
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M3 12h18" />
  </svg>
);

export const Building = () => (
  <svg {...stroke}>
    <path d="M4 21V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v15" />
    <path d="M14 10h4a2 2 0 0 1 2 2v9M3 21h18" />
    <path d="M7.5 8h3M7.5 12h3M7.5 16h3" />
  </svg>
);

export const Rocket = () => (
  <svg {...stroke}>
    <path d="M12 3c3 2 4.5 5 4.5 9 0 1.7-.45 3.4-1.3 4.9H8.8A10.7 10.7 0 0 1 7.5 12c0-4 1.5-7 4.5-9Z" />
    <path d="m8.8 16.9-2.8 2.6s.3-3 1.5-4.6M15.2 16.9l2.8 2.6s-.3-3-1.5-4.6" />
    <circle cx="12" cy="10" r="1.6" />
  </svg>
);

/* --- Project cover marks -------------------------------------------------- */

const cover = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 48 48",
  "aria-hidden": true,
};

export const CoverWellness = () => (
  <svg {...cover}>
    <rect x="6" y="10" width="16" height="16" rx="3" />
    <path d="M10 14h8M10 18h8M10 22h5" />
    <rect x="28" y="22" width="14" height="16" rx="3" />
    <path d="M35 26v8M31 30h8" />
    <path d="M22 18h4a3 3 0 0 1 3 3v1" />
    <circle cx="35" cy="12" r="5" />
    <path d="M33 12h4M35 10v4" />
  </svg>
);

export const CoverAi = () => (
  <svg {...cover}>
    <rect x="15" y="15" width="18" height="18" rx="4" />
    <path d="M21 21h6M21 27h6" />
    <path d="M24 15V8M24 33v7M15 24H8M33 24h7" />
    <path d="M18.5 15v-4M29.5 15v-4M18.5 33v4M29.5 33v4" />
    <circle cx="24" cy="8" r="2" />
    <circle cx="8" cy="24" r="2" />
    <circle cx="40" cy="24" r="2" />
    <circle cx="24" cy="40" r="2" />
  </svg>
);

export const CoverHealth = () => (
  <svg {...cover}>
    <path d="M6 24h7l3-7 5 15 4-11 3 3h14" />
    <circle cx="38" cy="12" r="4" />
    <path d="M34 12a8 8 0 0 1-16 0V7" />
    <path d="M15 7h6" />
  </svg>
);
